import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import ManualDataPull from "client_config/ManualDataPull";
import CurrencySelector from "client_config/CurrencySelector";
import jsDig from "utils/jsDig.js";
import CustomFormCheck from "utils/CustomFormCheck";
import { Form } from "react-bootstrap";

export default function IdsData(props) {
  let platforms = [
    {
      name: "shopify",
      id: "pull-shopify",
      label: "Pull Shopify data on save",
    },
  ];

  const [platformEnabled, setPlatformEnabled] = useState(
    jsDig(["platform_data", "shopify", "enabled"], props.ppc_section) ? jsDig(["platform_data", "shopify", "enabled"], props.ppc_section) : false
  );

  const [baseCurrency, setBaseCurrency] = useState(props.ppc_section.base_currency)
  const [displayCurrency, setDisplayCurrency] = useState(props.ppc_section.display_currency)

  return (
    <div className="top-div ml-0 ml-md-3 p-3">
      <Row className="py-4 px-0 px-md-4 justify-content-between">
        <Col xs={12} lg={5}>
          <div>
            <span className="text-info visby-bold pt-3 f-18">
              Shopify Data
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message="List your shopify URL below and also select whether you want to pull shopify sales data from only `Online Store` or `All Sales Channels`"
                inline={true}
              />
            </span>
            <div style={{ backgroundColor: "#F5F5F5" }} className="table-responsive mt-3 px-4 pb-2 pt-3">
              <div>
                <CustomFormCheck
                  id="ppc-shopify-ads-id"
                  label={`Enable Shopify`}
                  checked={platformEnabled}
                  name={`[platform_data][ppc][shopify][enabled]`}
                  sendUncheckedValue
                  onChange={() => {
                    setPlatformEnabled(!platformEnabled);
                  }}
                />
              </div>
              <div className="mt-3 pb-3">
                <p className="d-inline f14 nunito-regular mr-3 primary">Shopify URL</p>
                <Form.Control
                  className="d-inline pl-3"
                  // disabled={!platformEnabled}
                  readOnly={!platformEnabled}
                  size="sm"
                  style={{ width: "375px", backgroundColor: !platformEnabled ? "#F8F8F8" : "white" }}
                  name={`[platform_data][ppc][shopify][url]`}
                  defaultValue={jsDig(["shopify_url"], props.client_account)}
                />
              </div>
              <div className="shopify-revenue-type pb-3">
                <p className="visby-bold">Shopify revenue type</p>
                <Form.Check
                  name="shopify_revenue_type"
                  value="online_store"
                  custom
                  label="Online Store Sales Only"
                  type="radio"
                  id="shopify_revenue_type_0"
                  defaultChecked={props.ppc_section.shopify_revenue_type === "online_store" ? true : false}
                />
                <Form.Check
                  name="shopify_revenue_type"
                  value="overall"
                  custom
                  label="All Sales Channels"
                  type="radio"
                  id="shopify_revenue_type_1"
                  defaultChecked={props.ppc_section.shopify_revenue_type === "overall" ? true : false}
                />
            </div>
            </div>
          </div>
        </Col>
        <Col className="mt-3" xs={12} lg={7}>
          <ManualDataPull
            isEnabled={props.ppc_section.data_pull_enabled}
            platforms={platforms}
            service="ppc"
            shopify_token={props.client_account.shopify_token}
          />
        </Col>
      </Row>
      <Row className="py-4 px-0 px-md-4 justify-content-between">
        <Col xs={12} lg={5}>
          <h5 className="pl-1">Shopify Country Filter</h5>
          <div>
            <Form.Control
              className={`primary mb-2`}
              size="md"
              as="select"
              name="shopify_country_filter"
              defaultValue={props.ppc_section.shopify_country_filter}
              style={{ width: "256px" }}>
              {["none", "US", "CA"].map((country) => {
                return (
                  <option key={country} value={country}>
                    { country == "none" ? "None (pull everything)" : country }
                  </option>
                );
              })}
            </Form.Control>
          </div>
        </Col>
      </Row>
      <Row className="py-4 px-0 px-md-4">
        <Col xs={12} sm={6}>
          <h5 className="pl-1">Base Currency</h5>
          <CurrencySelector selectedCurrency={baseCurrency} setSelectedCurrency={setBaseCurrency} nameAttribute="video_base_currency" />
        </Col>
        <Col xs={12} sm={6}>
          <h5 className="pl-1">Display Currency</h5>
          <CurrencySelector selectedCurrency={displayCurrency} setSelectedCurrency={setDisplayCurrency} nameAttribute="video_display_currency" />
        </Col>
      </Row>
    </div>
  );
}
